import { render, staticRenderFns } from "./leverDetail.vue?vue&type=template&id=f1423f3c&scoped=true&"
import script from "./leverDetail.vue?vue&type=script&lang=js&"
export * from "./leverDetail.vue?vue&type=script&lang=js&"
import style0 from "./leverDetail.vue?vue&type=style&index=0&id=f1423f3c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1423f3c",
  null
  
)

export default component.exports